import { createRichTextComponent } from '../../components/richText/utils';

/**
 * Renders rich text field with Heading 1 styles.
 */
const Heading1 = createRichTextComponent('heading1');

export default Heading1;
